// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./clients/web/src/stylesheets/widgets/browserWidget.styl
// module id = 262
// module chunks = 0